import { GoogleAnalyticsEscriptEventName } from '@/hooks/analytics/types';
import useGoogleAnalytics from '@/hooks/analytics/useGoogleAnalytics';
import { hashedEmail } from '@/hooks/analytics/utils';
import { usePreOnboardingContext } from '@/hooks/escript/usePreOnboardingContext';
import { emitUIEvent } from '@montugroup/data-collection';
import { Box, Divider, Typography } from '@montugroup/design-system';
import { useEffect } from 'react';
import { ResendInviteButton } from '../ResendInviteButton';

export const ScriptValid = () => {
  const { customerDetails } = usePreOnboardingContext();
  const { sendGoogleAnalyticsEvent } = useGoogleAnalytics();
  const customerContactInfo = customerDetails?.phone || customerDetails?.email;

  // todo: emitUIEvent is an interim approach until the data collection package is updated with 'Data Events' schema
  useEffect(() => {
    sendGoogleAnalyticsEvent(GoogleAnalyticsEscriptEventName.PRESCRIPTION_SUBMIT_COMPLETE, {
      sha_email: customerDetails?.email ? hashedEmail(customerDetails?.email) : '',
      stock: 'available',
      product_match: 'validated',
    });

    emitUIEvent(
      {
        component_name: 'script_valid_screen',
        event_name: 'screenViewed',
        id: 'escript_onboarding_script_valid',
        value: 'script valid screen viewed',
      },
      [],
    );
  }, []);

  return (
    <>
      <Typography variant="subtitle1" fontWeight={600} data-testid="customer-escript-script-valid">
        Good news! Your medication is available.
      </Typography>
      <Typography>
        Create an account to order your medication. We&apos;ve sent an invite link to{' '}
        <Box component="span" fontWeight="bold">
          {customerContactInfo}.
        </Box>
      </Typography>

      <Typography>If your details have changed, please update them with your doctor.</Typography>

      <Divider />
      <Typography variant="body2">
        Didn&apos;t get the invite? <ResendInviteButton />
      </Typography>
    </>
  );
};
